import{SET_USERS_LIMIT_NUMBER as SOCKET_SET_USERS_LIMIT_NUMBER} from '../../events/DashboardToServer'
import{GET_USERS_LIMIT_NUMBER as SOCKET_GET_USERS_LIMIT_NUMBER} from '../../events/ClientToServer'

const SET_USERS_LIMIT_NUMBER = 'SET_USERS_LIMIT_NUMBER'
const GET_USERS_LIMIT_NUMBER = 'GET_USERS_LIMIT_NUMBER'
const USERS_LIMIT_NUMBER_SETTED = 'USERS_LIMIT_NUMBER_SETTED'
const USERS_LIMIT_NUMBER_SENT = 'USERS_LIMIT_NUMBER_SENT'

export const usersLimitNumber = (state = {}, action) => {
    switch (action.type) {
        case USERS_LIMIT_NUMBER_SETTED:
            var ss = {
                ...state,
            }
            ss.usersLimitNumber = action.usersLimitNumber
            return ss   

        case USERS_LIMIT_NUMBER_SENT:
            var ss = {
                ...state,
            }
            ss.usersLimitNumber = action.usersLimitNumber
            return ss               
        
        default:
            return state
    }
}


export const setUsersLimitNumber = (socket,usersLimitNumber) =>{
    socket.emit(SOCKET_SET_USERS_LIMIT_NUMBER, {usersLimitNumber})
    return {type:SET_USERS_LIMIT_NUMBER}
}

export const getUsersLimitNumber = (socket) =>{
    socket.emit(SOCKET_GET_USERS_LIMIT_NUMBER)
    return {type:GET_USERS_LIMIT_NUMBER}
}

export const usersLimitNumberSetted =(usersLimitNumber) =>{
    return {type:USERS_LIMIT_NUMBER_SETTED, usersLimitNumber:usersLimitNumber}
}

export const usersLimitNumberSent =(usersLimitNumber) =>{
    return {type:USERS_LIMIT_NUMBER_SENT, usersLimitNumber:usersLimitNumber}
}



// WEBPACK FOOTER //
// ./src/reducers/usersLimitNumber/index.js